import React, { useEffect, useState } from "react";
import MessageandFileDetails from "../../../../../../Common/ChatComponent/MessageandFileDetails";
import { useRouteBaseStateContext } from "../../../../../../../Context/RouteBaseStateContext";

export default function MineActiveProjectMessagesFiles({ posts }) {
  const { urlstate } = useRouteBaseStateContext();

  const [scroll, setScroll] = useState(0)

  useEffect(() => {
    if (urlstate) {
      setScroll(prev => prev + 1);
    }
  }, [urlstate]);
  return (
    <div>
      <MessageandFileDetails posts={posts} scroll={scroll} />
    </div>
  );
}
